import { XF } from "./js/XF";

/**
 * Checks URL parameters and shows the smart login modal if applicable.
 */
async function checkAndShowSmartLogin() {
  // check for required utm_user trigger param
  const urlParams = new URLSearchParams(window.location.search);
  const utmUser = urlParams.get("utm_user");
  const utmCampaign = urlParams.get("utm_campaign");
  if (!utmUser || !utmCampaign) {
    return;
  }

  XF.loadOverlay(
    `/login/?onload=1&utm_user=${utmUser}&utm_campaign=${utmCampaign}`,
    {
      beforeShow(overlay) {
        // Adds our custom class if the smart login is about to show
        overlay.$container.addClass("smart-login-overlay");
      },
      init: (overlay) => {
        overlay.$container.one("overlay:hidden", () => {
          XF.ajax("post", "/login/dismiss-smart-login");
        });
      },
    }
  );
}

checkAndShowSmartLogin();

// Adds our custom class if the smart login is about to show
$(document).on("overlay:showing", (e) => {
  const $overlay = $(e.target);
  if ($overlay.find(".login_smart").length) {
    $overlay.addClass("smart-login-overlay");
  }
});
